<template>
    <div class="page projects-page">
        <div class="project-filters">
            <ul>
                <li v-for="(filter, index) in filters" :key="index">
                    <a
                        href="#"
                        class="cool-link"
                        :class="{ active: filter === projectsFilter }"
                        @click.prevent="filterBy(filter)"
                    >
                        {{ filter }}
                    </a>
                </li>
            </ul>
        </div>
        <transition-group class="project-list" name="project-list" tag="div">
            <div
                class="project-card"
                v-for="project in filteredProjects"
                :key="project.id"
                @click="viewProject(project.id)"
            >
                <div class="project-thumb" v-show="!loading">
                    <img :src="project.cover" />
                </div>
                <h4 class="project-title" v-show="!loading">
                    {{ project.title }}
                </h4>
                <h6 class="project-type" v-show="!loading">
                    {{ project.type }}
                </h6>
                <b-skeleton
                    v-if="loading"
                    width="320px"
                    height="320px"
                ></b-skeleton>
                <b-skeleton
                    v-if="loading"
                    width="200px"
                    position="is-centered"
                ></b-skeleton>
                <b-skeleton
                    v-if="loading"
                    width="150px"
                    position="is-centered"
                ></b-skeleton>
            </div>
        </transition-group>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

let loading = true

export default {
    name: 'Projects',
    data() {
        return {
            loading,
            filters: [
                'All',
                'AI',
                'React',
                'Vue.js',
                'Next.js',
                'Node.js',
                'Express.js',
                'TypeScript',
                'JavaScript',
                'Socket.IO',
                'jQuery',
                'Bootstrap',
                'Bulma',
                'CSS',
                'Laravel',
                'PHP',
                'Firebase',
                'MongoDB',
                'MySQL',
            ],
        }
    },
    computed: {
        ...mapGetters(['filteredProjects', 'projectsFilter']),
    },
    mounted() {
        if (this.loading) {
            setTimeout(() => {
                this.loading = loading = false
            }, 1500)
        }
    },
    methods: {
        filterBy(filter) {
            if (this.loading) {
                return
            }
            this.$store.dispatch('filterProjects', filter)
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            })
        },
        viewProject(id) {
            this.$router.push({
                name: 'project',
                params: {
                    id,
                },
            })
        },
    },
}
</script>
